"use client";

import { useEffect } from "react";

import { captureAdClick } from "@/lib/ad-click";

/** Remembers the ad click a traveler landed from. Mounted only when the Meta
 *  Ads or Google Ads app emitted a script, so other storefronts keep nothing. */
export function AdClickCapture(): null {
  useEffect(() => {
    captureAdClick(window.location.search);
  }, []);
  return null;
}
